import styled from 'styled-components'
import { IconButton } from '@material-ui/core'

export const QuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.125rem;

  .MuiIconButton-root {
    padding: 0.25rem;
  }
`

export const QuantityInput = styled.input`
  width: 1.75rem;
  padding: 0.25rem;
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  font-family: ${({ theme }) => theme.ds.typography.fontFamilySecondary};
  color: ${({ theme }) => theme.ds.colors.neutral900};
  text-align: center;
  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.ds.typography.border.radius.xxsmall};
  outline: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.ds.colors.neutral50};
  }

  &:focus {
    cursor: text;
    border-color: ${({ theme }) => theme.ds.colors.primary600};
    background-color: ${({ theme }) => theme.ds.colors.white};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.ds.colors.primary100};
  }
`

export const EditIconButton = styled(IconButton)`
  && {
    svg path {
      fill: ${({ theme }) => theme.ds.colors.textPrimary};
    }

    &:hover {
      svg path {
        fill: ${({ theme }) => theme.ds.colors.primary600};
      }
    }
  }
`
